module.exports = __webpack_public_path__ + "static/videoThumbnail-41fd5ec71dddf5b4074eb241b6b49d4a.png";